import { useState } from "react";
import { AsyncThunk } from "@reduxjs/toolkit";

import { useAppDispatch } from "@/store/hooks";
import { handleIsInfiniteScrollFilterChanges } from "@/store/slices/config";

interface InfiniteScrollParams<TFilters = void> {
  fetchFn: AsyncThunk<any, TFilters, any>; // Function to fetch initial data
  fetchNextFn: AsyncThunk<any, TFilters, any>; // Function to fetch next page
}

const useInfiniteScroll = <TFilters extends Record<string, any>>(
  params: InfiniteScrollParams<TFilters>
) => {
  const { fetchFn, fetchNextFn }: any = params;
  const dispatch = useAppDispatch();
  const [page, setPage] = useState<number>(1);

  const handleFetch = (filters: TFilters) => {
    dispatch(
      fetchFn({
        page: 1,
        ...filters,
      })
    );
    dispatch(handleIsInfiniteScrollFilterChanges());
    setPage(1);
  };

  const handleFetchNext = (filters: TFilters) => {
    const nextPage = page + 1;
    dispatch(
      fetchNextFn({
        page: nextPage,
        ...filters,
      })
    );
    setPage(nextPage);
  };

  const handleResetPage = () => {
    setPage(1);
  };

  return {
    handleFetchNext,
    handleFetch,
    handleResetPage,
    currentPage: page,
  };
};

export default useInfiniteScroll;
